import React, { useState } from "react";
import "./StaffDirectory.css";
import { FaChalkboardTeacher, FaPhone, FaEnvelope, FaPlus } from "react-icons/fa";

const StaffDirectory = () => {
  const [staff] = useState([
    { id: 1, name: "Priya Sundaram", role: "Head Teacher", classAssigned: "Nursery A", phone: "+91 98765 43210", email: "priya@wisdompreschool.com" },
    { id: 2, name: "Anita Roy", role: "Assistant Teacher", classAssigned: "Playgroup B", phone: "+91 98765 43211", email: "anita@wisdompreschool.com" },
    { id: 3, name: "Vikram Malhotra", role: "Administrator", classAssigned: "All Classes", phone: "+91 98765 43212", email: "admin@wisdompreschool.com" },
  ]);

  return (
    <div className="staff-container">
      <div className="staff-header">
        <h2><FaChalkboardTeacher /> Staff & Teacher Directory</h2>
        <button className="btn-primary"><FaPlus /> Add Staff Member</button>
      </div>

      <div className="staff-grid">
        {staff.map((member) => (
          <div key={member.id} className="staff-card">
            <div className="staff-avatar">{member.name.charAt(0)}</div>
            <div className="staff-details">
              <h3>{member.name}</h3>
              <span className="staff-role">{member.role}</span>
              <span className="staff-class">Assigned: {member.classAssigned}</span>
              <div className="staff-contact">
                <span><FaPhone /> {member.phone}</span>
                <span><FaEnvelope /> {member.email}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StaffDirectory;